// remove diacritics and convert to lowercase
/**
 * @example
 * normalizeText('Česká Republika') => 'ceska republika'
 */
export const normalizeText = (text: string) =>
  text
    .toLowerCase()
    // extract diacritics: break č to c and ˇ
    .normalize('NFD')
    // remove diacritics: ˇ to nothing and keep just c
    .replace(/[\u0300-\u036f]/g, '')
